// composables/useProjectCategories.ts
import { computed } from "vue";
import type { Category } from "~/types/projects";

export function useCategories(project: Ref<{ categories?: number[] } | null>) {
  const storeCategories = useStoreCategories();
  const projectCategories = computed(() => {
    if (!project.value?.categories || !storeCategories.categories.length)
      return [];
    return project.value.categories
      .map((catId) => storeCategories.categories.find((c) => c.id === catId))
      .filter((c): c is Category => !!c);
  });

  const projectCategoriesSlug = computed(() =>
    projectCategories.value.map((c) => c.slug).join(" ")
  );

  return {
    projectCategories,
    projectCategoriesSlug,
  };
}
